export default __webpack_public_path__ + "static/media/11.b9e1f9dd.webp";